import { combineReducers } from 'redux';
import user from './user';
import runtime from './runtime';
import home from './home';
import matches from './matches';
import videoDetail from './video-detail';
import vod from './vod';
import banner from './banner';
import seriesDetail from './series-detail';
import channels from './channels';
import vuid from './vuid';
import recommendedVideos from './recommended-videos';
import articlesDetail from './articles-detail';
import recommendedArticles from './recommended-articles';
import relatedArticles from './related-articles';
import liveNotification from './live-notification';
import homeArticles from './home-articles';
import qrcode from './qrcode';
import { reducer as toastr } from 'react-redux-toastr';
import newArticles from './new-articles';
import configParams from './config-params'

export default combineReducers({
  user,
  runtime,
  home,
  matches,
  channels,
  videoDetail,
  vod,
  banner,
  seriesDetail,
  recommendedVideos,
  vuid,
  toastr,
  articlesDetail,
  recommendedArticles,
  relatedArticles,
  liveNotification,
  qrcode,
  homeArticles,
  newArticles,
  configParams
});
